export default (function (phoneNumber) {
    if (!phoneNumber)
        return '+48';
    return phoneNumber.split(' ')[0];
});
